import { useState, useEffect } from 'react';
import { supabase } from './supabase';

const DEFAULT_CUSTOMER_TYPES = ['Architect / Designer', 'Contractor', 'Individual', 'Planning Consultant'];
const DEFAULT_SERVICE_TYPES = ['CMP', 'CEMP', 'CDM', 'CLP', 'CMS', 'CTMP', 'CLMP', 'DCMP', 'DCMLP', 'SPA', 'EC', 'Transport Statement', 'Travel Plan', 'Road Design', 'Waste Management Plan', 'Air Quality', 'Other'];

let cache = null;

export function useSettings() {
  const [customerTypes, setCustomerTypes] = useState(cache?.customerTypes || DEFAULT_CUSTOMER_TYPES);
  const [serviceTypes, setServiceTypes] = useState(cache?.serviceTypes || DEFAULT_SERVICE_TYPES);

  useEffect(() => {
    if (cache) return;
    supabase.from('settings').select('*').then(({ data }) => {
      if (data) {
        const ct = data.find(r => r.key === 'customer_types')?.value || DEFAULT_CUSTOMER_TYPES;
        const st = data.find(r => r.key === 'service_types')?.value || DEFAULT_SERVICE_TYPES;
        cache = { customerTypes: ct, serviceTypes: st };
        setCustomerTypes(ct);
        setServiceTypes(st);
      }
    });
  }, []);

  return { customerTypes, serviceTypes };
}
